<template>
  <div class="app-single-top-up-success">
    <slot name="txtBefore">
    </slot>
    <b-row class="single-topup-amount">
      <b-col cols="12" md=""><label><slot name="lblAmount">Aufladebetrag</slot></label></b-col>
      <b-col cols="12" md=""><span class="amount">{{formattedAmount}}</span></b-col>
    </b-row>
    <b-row class="single-topup-payment-type">
      <b-col cols="12" md=""><label><slot name="lblPaymentType">Ihre Zahlungsart:</slot></label></b-col>
      <b-col cols="12" md="">
        <span class="payment-type" v-if="isBankAccount">
          <slot name="lblTypeBank">Lastschrift</slot>
      </span>
        <span class="payment-type" v-if="isCreditCard">
          <slot name="lblTypeCredit">Kreditkarte</slot>
      </span>
      </b-col>
    </b-row>
    <PaymentInformation :payment="payment">
      <template v-for="slot in possibleChildSlotsFor('Payment')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </PaymentInformation>
    <slot name="txtAfter">
    </slot>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import slotProxy from '../../../../../mixins/slotProxy'
import configBasedTopUpPrice from '@/mixins/configBasedTopUpPrice'
import PaymentInformation from '@/components/process/generic/Payment/PaymentInformation.vue'

export const stepName = 'success'

export default {
  name: 'SingleTopUpSuccessWithPayment',
  components: { PaymentInformation },
  mixins: [
    configBasedTopUpPrice,
    slotProxy()
  ],
  computed: {
    ...mapGetters('topUp/single', [
      'amount'
    ]),
    formattedAmount: function () {
      return this.price(this.amount)
    },
    isCreditCard () {
      return this.payment.type === 'creditCard'
    },
    isBankAccount () {
      return this.payment.type === 'bankAccount'
    }
  },
  props: {
    payment: {
      type: Object
    }
  }
}
</script>
